import React from 'react'
import GetInTouch from './GetInTouch'
import Footer from './Footer'
import Newsletter from './NewsLetter'
import partnerImage2 from '../assets/partnerImage2.jpg';
import PartnerTop from './PartnerTop';
import partnerImage1 from '../assets/partnerImage1.png';




const PartnerWithUs = () => {
  return (
    <div>
        
<PartnerTop  largeHeading="Partner With Us" smallHeading="Partner With Us" image={partnerImage1}/>

    {/* why join warals ? */}

     <section className="py-5 bg-white">
      <div className="container">
        <h2 className="text-center fw-bold mb-2">Why join Warals?</h2>
        <div className="text-center mb-4">
          <hr className="underline mx-auto" />
        </div>
        <h5 className="text-center mb-5 fw-normal">
          For software vendors and consultants who are interested in distributing Warals Educational ERP
        </h5>

        <div className="row align-items-center">
          {/* Left Text */}
          <div className="col-md-7">
            <p className="text-secondary" style={{ textAlign: 'justify' }}>
              According to the research there are around 200 million schools in the world. So when we calculate it shows that to an average of one school in every square kilometer of world land mass. This is the amount of opportunity that has an actual need for warals educational ERP. The opportunity grows with the use of the product because it is not only designed for schools but also for institutions, colleges, universities, etc., which opens the wide gates for our partners to sell the product which is already trusted by many.
            </p>
            <p className="text-secondary" style={{ textAlign: 'justify' }}>
              Warals wholeheartedly supports its partner who wants to provide the product to the organisation with the motive of expanding the family. We know the rising demand for Educational ERP after the major outbreak. In the present the suppliers only provide the solution to the organisations but when it comes to after sales service, they lack behind because of their non-technical background. Even if they provide a solution, they offer a high price for the minor problem. In this case the organisations end up uninstalling the software.
            </p>
            <button className="btn mt-3" data-bs-toggle="modal"
  data-bs-target="#getInTouchModal2" style={{backgroundColor:'rgb(4,180,228)', color: 'white'}}>Start Your Journey Today</button>
          </div>

          {/* Right Image */}
          <div className="col-md-5 text-center mt-5 mt-md-0">
            <img
              src={partnerImage2}
              alt="Why Join Warals Illustration"
              className="img-fluid"
              style={{ maxHeight: '400px' }}
            />
          </div>
        </div>
      </div>
    </section>

    {/* <Newsletter/> */}
    <GetInTouch/>
    <Footer/>

  <div
  className="modal fade"
  id="getInTouchModal2"
  tabIndex="-1"
  aria-labelledby="getInTouchModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered modal-lg">
    <div className="modal-content border-0 shadow-lg rounded-4" style={{ overflow: "hidden" }}>
      <div className="modal-header bg-white border-0 pt-4 px-4 pb-2">
        <h5
          className="modal-title fw-bold"
          id="getInTouchModalLabel"
          style={{ color: "rgb(4,180,228)", fontSize: "2.2rem" }}
        >
          Let's Start
        </h5> 
        <button 
          type="button" 
          className="btn-close" 
          data-bs-dismiss="modal" 
          aria-label="Close"
          style={{ fontSize: "1.2rem" }}
        ></button>
      </div>
      
      <hr style={{ 
        borderTop: "2px solid rgb(4,180,228)", 
        opacity: "1", 
        margin: "0 1.5rem" 
      }} />

      <div className="modal-body bg-white px-4 pb-4 pt-3 text-start">
        <form action="https://formsubmit.co/info@warals.com" method='POST'>
          <div className="row g-4 mb-3">
            <div className="col-md-6">
              <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.1rem" }}>
                Name
              </label>
              <input
                type="text"
                className="form-control border border-2 rounded-3 py-3 px-3"
                placeholder="Enter your name"
                name='Name'
                style={{ fontSize: "1.1rem" }}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.1rem" }}>
                Email
              </label>
              <input
                type="email"
                className="form-control border border-2 rounded-3 py-3 px-3"
                placeholder="Enter your email address"
                name='Email'
                style={{ fontSize: "1.1rem" }}
                required
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.1rem" }}>
              Mobile Number
            </label>
            <input
              type="tel"
              className="form-control border border-2 rounded-3 py-3 px-3"
              placeholder="Enter your mobile number"
              name='Mobile Number'
              style={{ fontSize: "1.1rem" }}
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label text-dark fw-semibold" style={{ fontSize: "1.1rem" }}>
              Select Product
            </label>
            <select
              className="form-select border border-2 rounded-3 py-3 px-3"
              style={{ fontSize: "1.1rem" }}
              required
            >
              <option value="">Select a product</option>
              <option value="School Management System">School Management System</option>
              <option value="Institute Management System">Institute Management System</option>
              <option value="Learning Management System">Learning Management System</option>
              <option value="Website Development">Website Development</option>
            </select>
          </div>

          <div className="text-center mt-4">
            <button
              type="submit"
              className="btn text-white px-5 py-3 fw-semibold"
              style={{
                backgroundColor: "rgb(4,180,228)",
                borderRadius: "12px",
                fontSize: "1.2rem",
                transition: "all 0.3s ease",
                width: "50%",
                minWidth: "200px"
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#00a8d4")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "rgb(4,180,228)")}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>



    </div>
  )
}

export default PartnerWithUs;


